import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'

import Home from '@/components/Home.vue'
import DoctorHome from '@/components/Doctor/Home.vue'

import DoctorApp from '@/components/Doctor/App.vue'
import DoctorRegister from '@/components/Doctor/Register.vue'
import DoctorDashboard from '@/components/Doctor/Dashboard.vue'
import DoctorProfile from '@/components/Doctor/Profile.vue'
import DoctorProfileDetails from '@/components/Doctor/ProfileDetails.vue'
import DoctorProfileNewOffice from '@/components/Doctor/ProfileNewOffice.vue'
import DoctorProfileOffice from '@/components/Doctor/ProfileOffice.vue'
import DoctorAvailabilities from '@/components/Doctor/Availabilities.vue'
import DoctorEmergencies from '@/components/Doctor/Emergencies.vue'

import PatientSearch from '@/components/Patient/Search.vue'
import PatientEmergencyNew from '@/components/Patient/EmergencyNew.vue'
// import PatientOfficeTimeslotsShow from '@/components/Patient/OfficeTimeslotsShow.vue'
import PatientOfficeShow from '@/components/Patient/OfficeShow.vue'
import PatientTimeslotShow from '@/components/Patient/TimeslotShow.vue'
import PatientPartnerOfficeShow from '@/components/Patient/PartnerOfficeShow.vue'
import PatientPartnerTimeslotShow from '@/components/Patient/PartnerTimeslotShow.vue'
import PatientAppointmentShow from '@/components/Patient/AppointmentShow.vue'
import PatientInvitationShow from '@/components/Patient/InvitationShow.vue'

import { store } from '@/store'

Vue.use(Router)

const routesOptions = [
    {
        path: '*',
        redirect: '/'
    },
    {
        path: '/',
        // redirect: '/doctor'
        component: Home,
        meta: { layout: 'PatientLayout' }
    },
    {
        path: '/search',
        name: 'search',
        component: PatientSearch,
        meta: { layout: 'PatientLayout' }
    },
    {
        path: '/emergency',
        name: 'emergency.new',
        component: PatientEmergencyNew,
        meta: { layout: 'PatientLayout' }
    },
    {
        path: '/appointment/:id',
        name: 'appointment.show',
        component: PatientAppointmentShow,
        meta: {
            layout: 'PatientLayout',
            analytics: {
                pageviewTemplate (route) {
                    return {
                        page: 'appointment/:id',
                        title: 'appointment.show'
                    }
                }
            }
        }
    },
    {
        path: '/office/:id',
        name: 'office.show',
        component: PatientOfficeShow,
        meta: {
            layout: 'PatientLayout',
            analytics: {
                pageviewTemplate (route) {
                    return {
                        page: 'office/:id',
                        title: 'office.show'
                    }
                }
            }
        }
    },
    {
        path: '/partner-timeslot',
        name: 'partner-timeslot.show',
        component: PatientPartnerTimeslotShow,
        meta: {
            layout: 'PatientLayout',
            analytics: {
                pageviewTemplate (route) {
                    return {
                        page: 'partner-timeslot',
                        title: 'partner-timeslot.show'
                    }
                }
            }
        }
    },
    {
        path: '/partner-office',
        name: 'partner-office.show',
        component: PatientPartnerOfficeShow,
        meta: {
            layout: 'PatientLayout',
            analytics: {
                pageviewTemplate (route) {
                    return {
                        page: 'partner-office',
                        title: 'partner-office.show'
                    }
                }
            }
        }
    },
    {
        path: '/timeslot/:id',
        name: 'timeslot.show',
        component: PatientTimeslotShow,
        meta: {
            layout: 'PatientLayout',
            analytics: {
                pageviewTemplate (route) {
                    return {
                        page: 'timeslot/:id',
                        title: 'timeslot.show'
                    }
                }
            }
        }
    },
    {
        path: '/invitation/:id',
        name: 'invitation.show',
        component: PatientInvitationShow,
        meta: {
            layout: 'PatientLayout',
            analytics: {
                pageviewTemplate (route) {
                    return {
                        page: 'invitation/:id',
                        title: 'invitation.show'
                    }
                }
            }
        }
    },
    {
        path: '/doctor/login',
        name: 'doctor.login',
        component: DoctorHome,
        meta: { layout: 'DoctorLayout' }
    },
    {
        path: '/doctor/register',
        name: 'doctor.register',
        component: DoctorRegister,
        meta: { layout: 'DoctorLayout', requiresAuth: true }
    },
    {
        path: '/doctor',
        component: DoctorApp,
        meta: { layout: 'DoctorLayout', requiresAuth: true, doctorAuth: true },
        children: [
            {
                path: '',
                name: 'doctor.dashboard',
                component: DoctorDashboard
            },
            {
                path: 'profile',
                component: DoctorProfile,
                children: [
                    {
                        path: '',
                        name: 'doctor.profile',
                        component: DoctorProfileDetails
                    },
                    {
                        path: 'new-office',
                        name: 'doctor.profile.newOffice',
                        component: DoctorProfileNewOffice
                    },
                    {
                        path: 'office/:id',
                        name: 'doctor.profile.office',
                        component: DoctorProfileOffice,
                        meta: {
                            analytics: {
                                pageviewTemplate (route) {
                                    return {
                                        page: 'doctor/profile/office/:id',
                                        title: 'doctor.profile.office'
                                    }
                                }
                            }
                        }
                    }
                ]
            },
            {
                path: 'availabilities',
                name: 'doctor.availabilities',
                component: DoctorAvailabilities
            },
            {
                path: 'emergencies',
                name: 'doctor.emergencies',
                component: DoctorEmergencies
            }
        ]
    }
]

var router = new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    linkExactActiveClass: 'is-active',
    routes: routesOptions.map(route => {
        return route
    })
})

router.beforeEach((to, from, next) => {
    // Reset the body class if necessary
    if (store.state.preventBodyScroll === true) {
        store.commit('setPreventBodyScroll', false)
    }

    let recordWithLayout = to.matched.slice().reverse().find(record => record.meta && record.meta.layout)
    if (store.getters.layout != recordWithLayout.meta.layout) {
        store.commit('SET_LAYOUT', recordWithLayout.meta.layout)
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (to.matched.some(record => record.meta.doctorAuth)) {
            if (! store.state.userId) {
                // User is not signed in
                // console.log('doctorAuth, no userId -> /doctor/login', to, from)
                next('/doctor/login')
                return
            }

            if (! store.state.doctor) {
                // User is not a doctor
                // console.log('doctorAuth, userId but not a doctor -> /doctor/register', to, from)
                next('/doctor/register')
                return
            }
        }

        if (! store.state.userId) {
            // console.log('requiresAuth, no userId -> /', to, from)
            next('/')

            return
        }
    }

    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js